module.exports = __webpack_public_path__ + "static/media/furia-work.d75867fc.svg";